export default "__VITE_ASSET__vG5xJA_y__"